import React from 'react'
import { Button } from '../../../components'
import { isInternal } from '../../../shared/utils'
import { postToolButtonType } from '../../../types'
import style from './style.module.scss'

type toolTileProps = {
    title: string
    subtitle?: string
    excerpt: string
    buttons: postToolButtonType[]
    image: {
        alt: string | false
        url: string | false
    }
}

export const ToolTile: React.FC<toolTileProps> = ({ image, title, subtitle, excerpt, buttons }) => {
    const toButtonProps = (toolButton: postToolButtonType) => {
        const isLink = toolButton.type === 'link'
        const link = isLink
            ? toolButton.link?.url ?? '/'
            : toolButton.file
            ? toolButton.file.url
            : '/'
        const type: 'arrow' | 'angle' = toolButton.style === 'arrow' ? 'arrow' : 'angle'

        return {
            text: toolButton.text,
            link: link,
            type: type,
            blank: Boolean(toolButton.link?.target),
            isDownload: !isLink,
            isInternal: Boolean(link && isInternal(link)),
            picto: '',
            fullWidth: false,
        }
    }

    return (
        <div className={style.toolTile}>
            <div className={style.imgContainer}>
                {image.url && <img src={image.url} alt={image.alt || title} />}
            </div>

            <div className={style.content}>
                {subtitle && <div className={style.subtitle}>{subtitle}</div>}

                <h4 className={style.title}>{title}</h4>

                <p className={style.excerpt}>{excerpt}</p>

                <div className={style.buttons}>
                    {buttons.map((toolButton, i) => (
                        <Button key={i} {...toButtonProps(toolButton)} />
                    ))}
                </div>
            </div>
        </div>
    )
}
